import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.75 3.2063L0.75 8.93346M7.75 3.2063L14.75 8.93346M7.75 3.2063L14.75 0.706299V8.93346M7.75 3.2063L0.75 0.706299L0.75 8.93346M7.75 3.2063L7.75 14.7063M14.75 8.93346L10.75 10.7063L10.75 14.7063H7.75M0.75 8.93346L4.75 10.7063L4.75 14.7063H7.75",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgCat;
